import { Divider, Typography } from '@mui/material';

export interface SectionDividerProps {
    title: string;
    dividerMarginBottom?: number;
}

export const SectionDivider = ({
    title,
    dividerMarginBottom = 1,
}: SectionDividerProps) => {
    return (
        <>
            <Typography variant="subtitle2" marginTop={2}>
                {title}
            </Typography>
            <Divider sx={{ mb: dividerMarginBottom }} />
        </>
    );
};
